// qs-SilhouetteSection.vue
<template>
  <SilhouetteControl
    :current-silhouette="currentSilhouette"
    :is-visible="silhouetteVisible"
    @visibility-changed="handleSilhouetteVisibilityChanged"
    @silhouette-changed="handleSilhouetteChanged"
    @color-changed="handleSilhouetteColorChanged"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SilhouetteControl from '@/components/panels/qs-SilhouetteControl.vue'
import { useSilhouetteStore } from '@/stores/qs-store-silhouette'
import type { Silhouette } from '@/types/qs-type-silhouette'

const emit = defineEmits<{
  'silhouette-changed': [silhouette: Silhouette]
  'silhouette-visibility-changed': [visible: boolean]
  'silhouette-color-changed': [color: string]
}>()

const silhouetteStore = useSilhouetteStore()

const currentSilhouette = computed(() => silhouetteStore.currentSilhouette)
const silhouetteVisible = computed(() => silhouetteStore.isVisible)

const handleSilhouetteChanged = (silhouette: Silhouette) => {
  emit('silhouette-changed', silhouette)
}

const handleSilhouetteVisibilityChanged = (visible: boolean) => {
  emit('silhouette-visibility-changed', visible)
}

const handleSilhouetteColorChanged = (color: string) => {
  emit('silhouette-color-changed', color)
}
</script>